import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getCourseById, createCourse, updateCourse, deleteCourse } from "../services/api";

function CourseForm() {
  const { id } = useParams(); // Lấy id khóa học từ URL
  const isEdit = Boolean(id);
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [shortDesc, setShortDesc] = useState("");
  const [contentMd, setContentMd] = useState("");
  const [price, setPrice] = useState("");
  const [coverImage, setCoverImage] = useState(null);
  const [coverImageUrl, setCoverImageUrl] = useState("");
  const [isPublished, setIsPublished] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Load dữ liệu nếu đang chỉnh sửa
  useEffect(() => {
    if (isEdit) {
      getCourseById(id)
        .then((res) => {
          const course = res.data;
          setTitle(course.title);
          setShortDesc(course.short_desc || "");
          setContentMd(course.content_md || "");
          setPrice(course.price != null ? course.price.toString() : "");
          setCoverImageUrl(course.cover_image_url || "");
          setIsPublished(course.is_published || false);
        })
        .catch(() => setError("Không thể tải khóa học."));
    }
  }, [id, isEdit]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const formData = new FormData();
      formData.append("title", title);
      formData.append("short_desc", shortDesc);
      formData.append("content_md", contentMd);
      formData.append("is_published", isPublished);
      formData.append("price", price || 0);
      if (coverImage) {
        formData.append("cover_image", coverImage);
      }

      if (isEdit) {
        await updateCourse(id, formData);
        navigate("/khoa-hoc", { state: { message: "Cập nhật khóa học thành công!" } });
      } else {
        await createCourse(formData);
        navigate("/khoa-hoc", { state: { message: "Tạo khóa học thành công!" } });
      }
    } catch (err) {
      setError(err.response?.data?.error || "Đã có lỗi xảy ra");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("Bạn chắc chắn muốn xoá khóa học này?")) return;

    try {
      await deleteCourse(id);
      navigate("/khoa-hoc", { state: { message: "Xoá khóa học thành công!" } });
    } catch (err) {
      setError("Xoá thất bại");
    }
  };

  return (
    <div className="max-w-3xl mx-auto p-4 bg-white shadow rounded">
      <h2 className="text-xl font-bold mb-4">{isEdit ? "Chỉnh sửa khóa học" : "Tạo khóa học mới"}</h2>

      {error && <div className="text-red-500 mb-2">{error}</div>}

      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          className="w-full border p-2"
          placeholder="Tiêu đề khóa học"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />

        <textarea
          className="w-full border p-2"
          placeholder="Tóm tắt khóa học"
          value={shortDesc}
          onChange={(e) => setShortDesc(e.target.value)}
          required
        />

        <textarea
          className="w-full border p-2 h-40"
          placeholder="Nội dung chi tiết (Markdown)"
          value={contentMd}
          onChange={(e) => setContentMd(e.target.value)}
          required
        />

        <input
          type="number"
          className="w-full border p-2"
          placeholder="Giá khóa học (VND)"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          min="0"
          step="0.01"
        />

        <div>
          <label className="block mb-1 font-medium">Ảnh bìa:</label>
          <input type="file" accept="image/*" onChange={(e) => setCoverImage(e.target.files[0])} />
          {coverImageUrl && (
            <img src={coverImageUrl} alt="cover" className="mt-2 h-40 object-cover rounded" />
          )}
        </div>

        <label className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={isPublished}
            onChange={(e) => setIsPublished(e.target.checked)}
          />
          <span>Xuất bản khóa học</span>
        </label>

        <div className="flex space-x-4">
          <button
            type="submit"
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            disabled={loading}
          >
            {loading ? "Đang lưu..." : "Lưu"}
          </button>

          {isEdit && (
            <button
              type="button"
              onClick={handleDelete}
              className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
            >
              Xoá
            </button>
          )}
        </div>
      </form>
    </div>
  );
}

export default CourseForm;